const postMessage = (message: string) => {
  window.ReactNativeWebView?.postMessage(message);
};

export const vibrate = () => {
  postMessage(JSON.stringify(["vibrate"]));
};

export const changeAppStatusColor = (color: string) => {
  postMessage(JSON.stringify(["statusColor", color]));
};
